import dayjs from 'dayjs';
import { dayjsFormatDate } from '../Constants';

/**
 * Parses a username received from HCL Notes.
 * @param username - Raw username string.
 */
export const parseUsername = (username: string) =>
    username?.indexOf('CN=') === 0 ? username.replace('CN=', '').split('/')[0] : username;

/**
 * Parses a date string received from HCL Notes.
 * @param value - Raw date string.
 */
export const parseDate = (value: number | string) => value && dayjs(new Date(value)).format('L');

/**
 * Simple string sorting function.
 * @param a - First object.
 * @param b - Second object.
 * @returns Sorting index.
 */
export const stringSort = (a: string, b: string) => a.localeCompare(b);

/**
 * Simple date sorting function.
 * @param a - First object.
 * @param b - Second object.
 * @returns Sorting index.
 */
export const dateSort = (a: string, b: string) =>
    dayjs(a, dayjsFormatDate).isAfter(dayjs(b, dayjsFormatDate)) ? 1 : -1;

/** RegExp for a url validation. */
const urlPattern = /^(http(s)):\/\/.[\w#%+.:=@~-]{2,256}\.[a-z]{2,6}\b([\w#%&+./:=?@~-])*$/u;

/**
 * Validates url.
 * @param url Url string.
 * @returns boolean true if valid url.
 */
export const isValidUrl = (url?: string): boolean => {
    if (!url) {
        return;
    }
    return urlPattern.test(url);
};